// extracted by mini-css-extract-plugin
export default {"modal":"BookSlotModal_modal__cilx7","exit":"BookSlotModal_exit__N1mnc","card":"BookSlotModal_card__cEjVK","radioBtn":"BookSlotModal_radioBtn__9cB32"};